import React, { useRef }  from "react";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import emailjs from '@emailjs/browser';

function Contact(props) {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_TEMPLATEID, form.current, process.env.REACT_APP_PUBLICID)
      .then((result) => {
          alert("I've recieved your message");
    
      }, (error) => {
          alert("Message Not sent")
      });
  };
  return (
    <div id="contact">
      <section className="cd">
        <section className="cheader">
          <hr className="chr" /> CONTACT ME
        </section>
        <h3>Drop A Message</h3>
        <p>
          You can contact me on any of the numbers or send me a direct message
        </p>
        <section className="cicons">
          <section className="ic">
            <PhoneAndroidIcon id="ph" /> +233 257 307 607 <br />
            +233 249 209 171
          </section>

          <section className="ic">
            <MailOutlineIcon id="ph" /> codingbakelvin@gmail.com
          </section>

          <section className="ic">
            <LocationOnIcon id="ph" /> Sunyani- Bono <br /> Ghana
          </section>
        </section>
      </section>
      <section className="form" data-aos="fade-left">
        <form  ref={form} onSubmit={sendEmail}>
          <input type="text" placeholder="Name" name="name" required/>
          <input type="email" placeholder="Email"  name="email" required/>
          <input type="text" placeholder="Subject" name="subject"  />
          <textarea
            name="message"
            id=""
            cols="30"
            rows="10"
            placeholder="Message"
          required></textarea>

          <button type="submit">Send</button>
        </form>
        <section className="bg"></section>
      </section>
    </div>
  );
}

export default Contact;
